export const encodeHotelRoomConfig = configArr => {
	let resultStr = ''
	Array.isArray(configArr) &&
		configArr.forEach((room, i) => {
			resultStr =
				resultStr +
				'a' +
				room.adultCount +
				(room.childAges.length ? 'c' : '') +
				room.childAges.join('c')
			if (i + 1 < configArr.length) {
				resultStr = resultStr + 'r'
			}
		})

	return resultStr
}
